export default {
  IN_QUEUE: 'IN-QUEUE',
  PENDING: 'PENDING',
  INPROGRESS: 'INPROGRESS',
  PREVIEW_READY: 'PREVIEW_READY',
  READY: 'READY',
  FAILED: 'FAILED',
  NONE: 'NONE',
};



// WEBPACK FOOTER //
// ./src/transport/constants/transcoding-statuses.js